/*
  Тарифы: восемь величин, из которых складывается стоимость действия.

  🔴 Разбиты на три группы по происхождению денег (09.09.2026). До этого восемь
  полей шли одним столбиком во всю ширину экрана, и «Минута разговора» ничем не
  отличалась от «Доли исполнителя» - хотя первое приходит счётом от оператора
  связи, а второе решает владелец. Группы отвечают на вопрос «откуда я возьму
  это число», и заполнять их можно по одной, в разное время.

  Все восемь - числа не длиннее семи знаков, поэтому ширина у них наименьшая, и
  в группе они стоят в строку. Столбик из восьми полей по тысяче пикселей
  занимал экран целиком и читался как анкета, а не как прайс.
*/

import { LockedForm } from './AccessContext.jsx'
import { Field } from './Common.jsx'
import { asDecimal, asInput } from './entry/money.js'

const GROUPS = [
  {
    title: 'Связь с должником',
    hint: 'Цены приходят счётом от операторов связи и почты.',
    fields: [
      ['postal_cost', 'Почтовое отправление, ₽'],
      ['message_cost', 'Сообщение, ₽'],
      ['voice_minute_cost', 'Минута разговора, ₽'],
    ],
  },
  {
    title: 'Труд и сопровождение',
    hint: 'Ваши собственные затраты на дело: они решают, окупается ли подача.',
    fields: [
      ['service_package_cost', 'Пакет сопровождения, ₽'],
      ['support_hour_cost', 'Час юриста, ₽'],
      ['support_hours_per_case', 'Часов на дело'],
      ['our_share_percent', 'Доля исполнителя, %'],
    ],
  },
  {
    title: 'Языковая модель',
    hint: 'Разбор выгрузки и подготовка текстов.',
    fields: [['llm_thousand_requests_cost', 'Тысяча обращений, ₽']],
  },
]

/* `problems` - причины отказа по полям (`fieldErrors`): они встают под самим полем, а
   не одной фразой над формой (аудит 26.10.2026, причина 6). */
export default function SettingsTariffs({ economics, onSave, problems = {}, saving = false }) {
  return (
    <LockedForm
      busy={saving}
      onSubmit={(event) => {
        event.preventDefault()
        const form = new FormData(event.currentTarget)
        const keys = GROUPS.flatMap((group) => group.fields.map(([key]) => key))
        // «1,5» человек пишет с запятой, сервер ждёт точку; прежде такая цена отвергалась
        // с советом «копейки через запятую» (аудит 26.10.2026, причина 6).
        onSave(Object.fromEntries(keys.map((key) => [key, asDecimal(form.get(key) ?? '') || null])))
      }}
    >
      <p className="muted">
        Пустое поле - не ноль, а «пока не знаем»: по незаполненному тарифу гейт отдачи честно
        отвечает «посчитать нечем» и называет, чего не хватает.
      </p>

      {GROUPS.map((group) => (
        <fieldset className="group" key={group.title}>
          <legend className="group__title">{group.title}</legend>
          <p className="muted">{group.hint}</p>
          {/*
            `prices`, а не `row`: колонки одной ширины и подпись в одну строку.
            В гибкой строке поле было сто двадцать пикселей, а подписи требуют до
            ста пятидесяти семи - пять из восьми переносились на второй этаж, и
            ряд полей выглядел рваным (замер 09.09.2026, замечание владельца
            «наименование скачет»).
          */}
          <div className="prices">
            {group.fields.map(([key, label]) => (
              <Field key={key} label={label} error={problems[key]} errorId={`tariff-error-${key}`}>
                <input
                  className="field__input"
                  name={key}
                  inputMode="decimal"
                  defaultValue={asInput(economics[key])}
                  aria-invalid={problems[key] ? 'true' : undefined}
                  aria-describedby={problems[key] ? `tariff-error-${key}` : undefined}
                />
              </Field>
            ))}
          </div>
        </fieldset>
      ))}

      <button className="button" type="submit">
        {saving ? 'Сохраняем…' : 'Сохранить тарифы'}
      </button>
    </LockedForm>
  )
}
